import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = "Nandan Priyadarshi | Data PM, AI-native Builder and FDE",
  description = "Data Product Manager and AI-native builder who works directly with users, models the data, ships production workflows, and measures adoption.",
  keywords = "Nandan Priyadarshi, Data Product Manager, AI Product Manager, AI-native Builder, Forward Deployed Engineer, FDE, Solo Builder",
  ogImage = "/og-image.png",
  ogType = "website",
  canonicalUrl,
  noindex = false,
  author = "Nandan Priyadarshi",
  twitterHandle = "@nandanpri"
}) => {
  const siteUrl = "https://www.nandanpriyadarshi.com";
  const fullUrl = canonicalUrl ? `${siteUrl}${canonicalUrl}` : siteUrl;
  const fullImageUrl = ogImage.startsWith('http') ? ogImage : `${siteUrl}${ogImage}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      {noindex
        ? <meta name="robots" content="noindex, follow" />
        : <link rel="canonical" href={fullUrl} />}

      {/* Open Graph / Facebook / LinkedIn */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={title} />
      <meta property="og:site_name" content="Nandan Priyadarshi Portfolio" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
      <meta name="twitter:image:alt" content={title} />
      <meta name="twitter:creator" content={twitterHandle} />
      <meta name="twitter:site" content={twitterHandle} />
    </Helmet>
  );
};

export default SEO;
